<div class="buffer-selector-container">
    <div class="row center-item">
        <div class="col-12">
            <ng-container *ngIf="isBufferButtonMsgVisible">
                <app-tooltip *ngIf="mobileQuery.matches || fullScreen == false" class="tooltip-container"
                [Mensaje]="bufferButtonMsg" [isVisible]="isBufferButtonMsgVisible"
                (visibilityChange)="onVisibilityChange($event)">
                </app-tooltip>
            </ng-container>
            
            <button class="btnPin"
                mat-raised-button (click)="onSetBufferCenter()">
                <p class="btn-label center-item"><mat-icon class="example-tab-icon">control_point</mat-icon> Definir
                    Punto Activo</p>
            </button>
        </div>
    </div>
    <div class="row center-item">
        <div class="text-center" [hidden]="!isVisibleControlSliderRadio">
            <h3 class="radio-title">Radio Km</h3>
        </div>
        <mat-slider 
        [hidden]="!isVisibleControlSliderRadio" 
        thumbLabel name="radioSelector" 
        [displayWith]="formatLabel"
        step="0.2" 
        [min]="initialRadio" 
        max="5" 
        aria-label="kilometros" 
        showTickMarks discrete class="cdk-focused"
        (change)="onChangeRadio(inputSlider)">
            <input matSliderThumb [(ngModel)]="geofencesMapService.bufferRadioKm" #inputSlider>
        </mat-slider>
    </div>
</div>